const store = {
    Navigation: [
        {
            type: "link",
            label: "Home",
            url: "/"
        },
        {
            type: "link",
            label: "Gallery",
            url: "/gallery"
        },
        {
            type: "link",
            label: "Contact",
            url: "/contact"
        },
        {
            type: "link",
            label: "Impressum",
            url: "/impressum"
        }
    ],
    Galery: [
        {
            name: "Encaustic",
            teaser: {
                id: "0",
                name: "",
                path: require("@/assets/encaustic_teaser.jpg")
            },
            images: [
                {
                    id: "2",
                    name: "",
                    path: require("@/assets/encaustic_1920_1080_mit_wasserzeichen_2.jpg")
                },
                {
                    id: "3",
                    name: "",
                    path: require("@/assets/encaustic_1920_1080_mit_wasserzeichen_3.jpg")
                },
                {
                    id: "4",
                    name: "",
                    path: require("@/assets/encaustic_1920_1080_mit_wasserzeichen_4.jpg")
                },
                {
                    id: "5",
                    name: "",
                    path: require("@/assets/encaustic_1920_1080_mit_wasserzeichen_5.jpg")
                },
                {
                    id: "6",
                    name: "",
                    path: require("@/assets/encaustic_1920_1080_mit_wasserzeichen_6.jpg")
                },
                {
                    id: "7",
                    name: "",
                    path: require("@/assets/encaustic_1920_1080_mit_wasserzeichen_7.jpg")
                },
                {
                    id: "8",
                    name: "",
                    path: require("@/assets/encaustic_1920_1080_mit_wasserzeichen_8.jpg")
                },
                {
                    id: "9",
                    name: "",
                    path: require("@/assets/encaustic_1920_1080_mit_wasserzeichen_9.jpg")
                },
                {
                    id: "10",
                    name: "",
                    path: require("@/assets/encaustic_1920_1080_mit_wasserzeichen_10.jpg")
                },
                {
                    id: "11",
                    name: "",
                    path: require("@/assets/encaustic_1920_1080_mit_wasserzeichen_11.jpg")
                },
                {
                    id: "12",
                    name: "",
                    path: require("@/assets/encaustic_1920_1080_mit_wasserzeichen_12.jpg")
                },
                {
                    id: "13",
                    name: "",
                    path: require("@/assets/encaustic_1920_1080_mit_wasserzeichen_13.jpg")
                },
                {
                    id: "14",
                    name: "",
                    path: require("@/assets/encaustic_1920_1080_mit_wasserzeichen_14.jpg")
                },
                {
                    id: "15",
                    name: "",
                    path: require("@/assets/encaustic_1920_1080_mit_wasserzeichen_15.jpg")
                },
                {
                    id: "16",
                    name: "",
                    path: require("@/assets/encaustic_1920_1080_mit_wasserzeichen_16.jpg")
                },
                {
                    id: "17",
                    name: "",
                    path: require("@/assets/encaustic_1920_1080_mit_wasserzeichen_17.jpg")
                },
                {
                    id: "18",
                    name: "",
                    path: require("@/assets/encaustic_1920_1080_mit_wasserzeichen_18.jpg")
                },
                {
                    id: "19",
                    name: "",
                    path: require("@/assets/encaustic_1920_1080_mit_wasserzeichen_19.jpg")
                },
                {
                    id: "20",
                    name: "",
                    path: require("@/assets/encaustic_1920_1080_mit_wasserzeichen_20.jpg")
                }
            ]
        },
        {
            name: "Watercolor",
            teaser: {
                id: "0",
                name: "",
                path: require("@/assets/aquarell_teaser.jpg")
            },
            //aquarell_1920_1080_mit_wasserzeichen_21
            images: [
                {
                    id: "21",
                    name: "",
                    path: require("@/assets/aquarell_1920_1080_mit_wasserzeichen_21.jpg")
                },
                {
                    id: "22",
                    name: "",
                    path: require("@/assets/aquarell_1920_1080_mit_wasserzeichen_22.jpg")
                },
                {
                    id: "23",
                    name: "",
                    path: require("@/assets/aquarell_1920_1080_mit_wasserzeichen_23.jpg")
                },
                {
                    id: "24",
                    name: "",
                    path: require("@/assets/aquarell_1920_1080_mit_wasserzeichen_24.jpg")
                },
                {
                    id: "25",
                    name: "",
                    path: require("@/assets/aquarell_1920_1080_mit_wasserzeichen_25.jpg")
                },
                {
                    id: "26",
                    name: "",
                    path: require("@/assets/aquarell_1920_1080_mit_wasserzeichen_26.jpg")
                },
                {
                    id: "27",
                    name: "",
                    path: require("@/assets/aquarell_1920_1080_mit_wasserzeichen_27.jpg")
                },
            ]
        },
        {
            name: "Digital art",
            teaser: {
                id: "0",
                name: "",
                path: require("@/assets/digital-art_teaser.jpg")
            },
            images: [
                {
                    id: "1",
                    name: "",
                    path: require("@/assets/digital_art_1920_1080_mit_wasserzeichen_1.jpg")
                },
                {
                    id: "2",
                    name: "",
                    path: require("@/assets/digital_art_1920_1080_mit_wasserzeichen_2.jpg")
                },
                {
                    id: "3",
                    name: "",
                    path: require("@/assets/digital_art_1920_1080_mit_wasserzeichen_3.jpg")
                },
                {
                    id: "4",
                    name: "",
                    path: require("@/assets/digital_art_1920_1080_mit_wasserzeichen_4.jpg")
                },
                {
                    id: "5",
                    name: "",
                    path: require("@/assets/digital_art_1920_1080_mit_wasserzeichen_5.jpg")
                },
                {
                    id: "6",
                    name: "",
                    path: require("@/assets/digital_art_1920_1080_mit_wasserzeichen_6.jpg")
                },
                {
                    id: "7",
                    name: "",
                    path: require("@/assets/digital_art_1920_1080_mit_wasserzeichen_7.jpg")
                },
                {
                    id: "8",
                    name: "",
                    path: require("@/assets/digital_art_1920_1080_mit_wasserzeichen_8.jpg")
                },
                {
                    id: "9",
                    name: "",
                    path: require("@/assets/digital_art_1920_1080_mit_wasserzeichen_9.jpg")
                },
                {
                    id: "14",
                    name: "",
                    path: require("@/assets/digital_art_1920_1080_mit_wasserzeichen_14.jpg")
                },
                {
                    id: "16",
                    name: "",
                    path: require("@/assets/digital_art_1920_1080_mit_wasserzeichen_16.jpg")
                },
                {
                    id: "18",
                    name: "",
                    path: require("@/assets/digital_art_1920_1080_mit_wasserzeichen_18.jpg")
                },
                {
                    id: "20",
                    name: "",
                    path: require("@/assets/digital_art_1920_1080_mit_wasserzeichen_20.jpg")
                },
                {
                    id: "21",
                    name: "",
                    path: require("@/assets/digital_art_1920_1080_mit_wasserzeichen_21.jpg")
                },
                {
                    id: "22",
                    name: "",
                    path: require("@/assets/digital_art_1920_1080_mit_wasserzeichen_22.jpg")
                },
                {
                    id: "24",
                    name: "",
                    path: require("@/assets/digital_art_1920_1080_mit_wasserzeichen_24.jpg")
                },
                {
                    id: "25",
                    name: "",
                    path: require("@/assets/digital_art_1920_1080_mit_wasserzeichen_25.jpg")
                }
            ]
        },
        {
            name: "Acrylic",
            teaser: {
                id: "0",
                name: "",
                path: require("@/assets/acryl_teaser.jpg")
            },
            images: [
            ]
        },
        {
            name: "On Repeat",
            teaser: {
                id: "0",
                name: "On Repeat",
                path: require("@/assets/onrepeat/onrepeat_teaser.jpg")
            },
            //aquarell_1920_1080_mit_wasserzeichen_21
            images: [
                {
                    id: "22_6",
                    name: "On repeat - 17x 24 watercolor, acrylic pen, paint marker on rough watercolor paper",
                    path: require("@/assets/onrepeat/aquarell_1920_1080_mit_wasserzeichen_22_6.jpg")
                },
                {
                    id: "22_7",
                    name: "On repeat - 17x 24 watercolor, acrylic pen, paint marker on rough watercolor paper",
                    path: require("@/assets/onrepeat/aquarell_1920_1080_mit_wasserzeichen_22_7.jpg")
                },
                {
                    id: "22_8",
                    name: "On repeat - 17x 24 watercolor, acrylic pen, paint marker on rough watercolor paper",
                    path: require("@/assets/onrepeat/aquarell_1920_1080_mit_wasserzeichen_22_8.jpg")
                },
                {
                    id: "22_9",
                    name: "On repeat - 17x 24 watercolor, acrylic pen, paint marker on rough watercolor paper",
                    path: require("@/assets/onrepeat/aquarell_1920_1080_mit_wasserzeichen_22_9.jpg")
                },
                {
                    id: "22_10",
                    name: "On repeat - 17x 24 watercolor, acrylic pen, paint marker on rough watercolor paper",
                    path: require("@/assets/onrepeat/aquarell_1920_1080_mit_wasserzeichen_22_10.jpg")
                },
                {
                    id: "22_11",
                    name: "On repeat - 17x 24 watercolor, acrylic pen, paint marker on rough watercolor paper",
                    path: require("@/assets/onrepeat/aquarell_1920_1080_mit_wasserzeichen_22_11.jpg")
                },
                {
                    id: "22_12",
                    name: "On repeat - 17x 24 watercolor, acrylic pen, paint marker on rough watercolor paper",
                    path: require("@/assets/onrepeat/aquarell_1920_1080_mit_wasserzeichen_22_12.jpg")
                },
                {
                    id: "22_13",
                    name: "On repeat - 17x 24 watercolor, acrylic pen, paint marker on rough watercolor paper",
                    path: require("@/assets/onrepeat/aquarell_1920_1080_mit_wasserzeichen_22_13.jpg")
                },
                {
                    id: "22_14",
                    name: "On repeat - 17x 24 watercolor, acrylic pen, paint marker on rough watercolor paper",
                    path: require("@/assets/onrepeat/aquarell_1920_1080_mit_wasserzeichen_22_14.jpg")
                },
                {
                    id: "22_15",
                    name: "On repeat - 17x 24 watercolor, acrylic pen, paint marker on rough watercolor paper",
                    path: require("@/assets/onrepeat/aquarell_1920_1080_mit_wasserzeichen_22_15.jpg")
                },
                {
                    id: "22_16",
                    name: "On repeat - 17x 24 watercolor, acrylic pen, paint marker on rough watercolor paper",
                    path: require("@/assets/onrepeat/aquarell_1920_1080_mit_wasserzeichen_22_16.jpg")
                },
                {
                    id: "22_17",
                    name: "On repeat - 17x 24 watercolor, acrylic pen, paint marker on rough watercolor paper",
                    path: require("@/assets/onrepeat/aquarell_1920_1080_mit_wasserzeichen_22_17.jpg")
                },
                {
                    id: "22_18",
                    name: "On repeat - 17x 24 watercolor, acrylic pen, paint marker on rough watercolor paper",
                    path: require("@/assets/onrepeat/aquarell_1920_1080_mit_wasserzeichen_22_18.jpg")
                }
            ]
        }
    ]
};

export default store;